var recaptcha_contact_id = '';
var recaptcha_comment_id = '';
var recaptcha_register_id = '';
var recaptcha_error_id = '';

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function onloadCallback() {

    if($('#contact-recaptcha').length > 0){
        recaptcha_contact_id = grecaptcha.render('contact-recaptcha', {'sitekey' : '6LejKs0sAAAAALuu2yNr605vzT3rs1JkEMFjYnRV ', 'badge' : 'inline', 'callback' : 'enableContactSubmit'});
    }
    if($('#comment-recaptcha').length > 0){
        recaptcha_comment_id = grecaptcha.render('comment-recaptcha', {'sitekey' : '6LejKs0sAAAAALuu2yNr605vzT3rs1JkEMFjYnRV ', 'badge' : 'inline', 'callback' : 'enableCommentSubmit'});
    }
    if($('#register-recaptcha').length > 0){
        recaptcha_register_id = grecaptcha.render('register-recaptcha', {'sitekey' : '6LejKs0sAAAAALuu2yNr605vzT3rs1JkEMFjYnRV ', 'badge' : 'inline', 'callback' : 'enableRegisterSubmit'});
    }
    if($('#error-recaptcha').length > 0){
        recaptcha_error_id = grecaptcha.render('error-recaptcha', {'sitekey' : '6LejKs0sAAAAALuu2yNr605vzT3rs1JkEMFjYnRV ', 'badge' : 'inline', 'callback' : 'enableErrorSubmit'});
    }
}

function bodyCenter() {

    var left = document.querySelector('body').getBoundingClientRect().left;

    if (left != 0) {
        $('body').css('width', '100%');
        $('body').css('margin', '0 auto');
        $('body').css('position', 'relative');
        if (left < 0) {
            $('body').css('right', left);
        }
        else {
            $('body').css('right', 0);
        }
    }
}

$(document).ready(function(){
    
    bodyCenter();

    get_adult_confirm_alert();

    var video_id = $('#video_id');
    if (video_id[0] != null) {
        getVideoFrame();
    }

    $('html').attr('data-scroll', getWindowScrollPosition());
    bannerFixed();

    if($('#epoznan-apk-banner-container').length > 0) {

        $("#epoznan-apk-banner").click(function(event){
            if (event.target.id == 'epoznan-apk-banner') {
                setCookie('epoznan_apk_banner', '3', 365);
                window.location.href = '//apka.epoznan.pl';
            }
        });
        $("#epoznan-apk-banner-close").click(function(){
            $("#epoznan-apk-banner-container").hide();
            setCookie('epoznan_apk_banner', '3', 365);
        });

        var w = parseInt($(window).width());
        if (w > 450) {
            w = 450;
        }
        var h = "" + parseInt(w * 75 / 380) + "";
        $("#epoznan-apk-banner").css('height', h + "px");
        $("#epoznan-apk-banner-container").css('height', h + "px");

        var ua = navigator.userAgent.toLowerCase();
        var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
        if(isAndroid) {
            if ((getCookie('epoznan_apk_banner') == "") || (getCookie('epoznan_apk_banner') < 3)) {

                $("#epoznan-apk-banner-container").show();
                var c = getCookie('epoznan_apk_banner');
                if (c == "") {
                    c = 0;
                }
                c++;
                setCookie('epoznan_apk_banner', c, 365);
            }
        }
    }

    if(getCookie("epoznan_rodo_info_confirmed") == ""){
        $(".rodo-info-box").show();
        $(".rodo-info-box-overlay").show();
    }
    $(".rodo-accept").click(function(){
        $(".rodo-info-box").hide();
        $(".rodo-info-box-overlay").hide();

        var d = new Date();
        d.setTime(d.getTime() + (5 * 365 *24*60*60*1000));
        document.cookie = 'epoznan_rodo_info_confirmed=true;expires='+d.toUTCString()+';path=/';
    });
    $(".rodo-later").click(function(){
        $(".rodo-info-box").hide();
        $(".rodo-info-box-overlay").hide();
    });

    $('.no-on-culture-0').hide();

    if($('#event_id').length > 0){

        var event_id = $("#event_id").val();

        $.getJSON('/matchBoxClass?event_id='+event_id, function(data) {
            if (data.after_votes == '1') {
                $('.matchBox__teamPercent').addClass('matchBox__teamPercent--active');
            }
        });
    }

    adminEditLinks();

    $.getJSON('/getLoginPanel', function(data) {
        $('#header-login-button').html(data.view_header_login_panel);
        $('.commentsForm__header').html(data.view_header_comment_form_header);
        $('.commentsForm__additional-content').html(data.view_header_comment_form_content);
        $('.commentsForm__file-content').html(data.view_comment_form_file);
        if (data.form_display == 'hide') {
            $('#login-form-container').hide();
        }
    });

    var page = $('#comments_page_start').val();
    var news_id = $('#comments_news_id').val();
    var allow_comments = $('#news_allow_comments').val();
    var crisis_mode = $('#crisis_mode').val();

    $.getJSON('/newsIncView?id='+news_id, function(data) {});

    console.log("A");
    
    if ((allow_comments == 1) && (crisis_mode != 1)) {

        if(! $('#button-show-comments').length) {
            showComments(news_id, page, false);
        }
    }

    $('.gallery__container').magnificPopup({
        delegate: '.gallery__imageContainer, .gallery__masonryItem, .gallery__seeMore',
        gallery:{enabled:true},
        type: 'image'
    });
    $('.update__content').magnificPopup({
        delegate: '.update__photo-link',
        gallery:{enabled:true},
        type: 'image'
    });

    console.log("B");

    $("#login-button").click(function(){
        login('login-form');
    });
    $("#login-button-2").click(function(){
        login('login-form-2');
    });

    console.log("C");

    if (($('.postSidebar__errorButton').length > 0) && ($(window).width() >= 1420)) {
        showAdsys(39, 'news');
        showAdsys(38, 'news');
    }

    if (($('.largePhoto__button').length > 0) && ($(window).width() >= 1420)) {
        console.log("D");
        showAdsys(39, 'home');
        showAdsys(38, 'home');
    }

    $(".necro-content").each(function() {
        var id = $(this).attr('id');
        var id2 = id + "-inner";
        var height = $("#" + id2).height();
        var padding = (126 - height) / 2;
        $("#" + id).css("padding", padding + "px");
    });

    drawMap();

    prepareForms();

    var md_id = $("#md_id").val();
    if (getCookie("md_" + md_id) == '1') {
        $('.photosBattle__wrapper').addClass('photosBattle__wrapper--active');
    }

    if($('.hotNot__image').length > 0) {
        $('.hotNot__image').height($('.hotNot__image').width());
        $('.hotNot__image').resize(function() {
            $('.hotNot__image').height($('.hotNot__image').width());
        });
    }

    var hnt_id = $("#hnt_id").val();
    if (getCookie("hnt_" + hnt_id) == '1') {
        $('.hotNot__wrapper').addClass('hotNot__wrapper--active');
    }

    var javaHashFunction = new Fingerprint({hasher: javaHashCode});
    $('#canvas').val(javaHashFunction.get());
});

function prepareForms() {

    $("form#delete-comment-form").submit(function(e) {
        e.preventDefault();
        var formData = new FormData(this);
        $.ajax({
            url: '/deleteComment',
            type: 'post',
            data: formData,
            success: function (data) {
                $('#delete-comment-reason').val('');
                alertPopupEnd(data.message);
            },
            cache: false,
            contentType: false,
            processData: false
        });
    });

    $("form#comment-form").submit(function(e) {
        e.preventDefault();
        var javaHashFunction = new Fingerprint({hasher: javaHashCode});
        $('#canvas2').val(javaHashFunction.get());
        var formData = new FormData(this);
        $.ajax({
            url: '/addComment',
            type: 'post',
            data: formData,
            success: function (data) {
                if (data.status == 'success') {
                    $('ul#' + data.ul_append_id).append(data.view);
                    $('ul#' + data.ul_append_id).show();
                    $('#comment-form-answer-box').html('');
                    $('#comment-textarea').val('');
                    $('#answer-comment-id').val('0');
                    $('#comment-ready-to-send').val('0');
                    $('html, body').animate({ scrollTop: $('#comment-text-' + data.comment_id).offset().top - 86 }, 500);
                }
                alertPopup(data.message);
                grecaptcha.reset(recaptcha_comment_id);
            },
            cache: false,
            contentType: false,
            processData: false
        });
    });

    $("form#contact-form").submit(function(e) {
        e.preventDefault();
        var formData = new FormData(this);
        $.ajax({
            url: '/addAlarm',
            type: 'post',
            data: formData,
            success: function (data) {
                if (data.status == 'error') {
                    alertPopup(data.message);
                }
                else {
                    alertPopupEnd(data.message);
                    $('#contact-sender').val('');
                    $('#contact-textarea').val('');
                    if (($('#contact-reload-page').length) && ($('#contact-reload-page').val() == "1")) {
                        setTimeout(function(){
                            location.href = "//epoznan.pl";
                        }, 3000);
                    }
                }
                grecaptcha.reset(recaptcha_contact_id);
            },
            cache: false,
            contentType: false,
            processData: false
        });
    });

    $("#error-form").submit(function(e) {
        e.preventDefault();
        var formData = new FormData(this);
        $.ajax({
            url: '/sendErrorReport',
            type: 'POST',
            data: formData,
            success: function (data) {
                if (data.status == 'error') {
                    alertPopup(data.message);
                }
                else {
                    alertPopupEnd(data.message);
                    $('#error-textarea').val('');
                }
            },
            cache: false,
            contentType: false,
            processData: false
        });
    });

    $("#remember-password-form").submit(function(e) {
        e.preventDefault();
        var formData = new FormData(this);
        $.ajax({
            url: '/rememberPassword',
            type: 'POST',
            data: formData,
            success: function (data) {
                alertPopup(data.message);
            },
            cache: false,
            contentType: false,
            processData: false
        });
    });

    $("#confession-form").submit(function(e) {
        e.preventDefault();
        var formData = new FormData(this);
        $.ajax({
            url: '/sendConfessionForm',
            type: 'POST',
            data: formData,
            success: function (data) {
                alertPopup(data.message);
            },
            cache: false,
            contentType: false,
            processData: false
        });
    });

    $("#spotted-form").submit(function(e) {
        e.preventDefault();
        var formData = new FormData(this);
        $.ajax({
            url: '/sendSpottedForm',
            type: 'POST',
            data: formData,
            success: function (data) {
                alertPopup(data.message);
            },
            cache: false,
            contentType: false,
            processData: false
        });
    });
}

$(window).resize(function() {
    bodyCenter();
    $('html').attr('data-scroll', getWindowScrollPosition());
    moveAdsys19();
    bannerFixed();
});

$(window).scroll(function() {
    $('html').attr('data-scroll', getWindowScrollPosition());
    bannerFixed();
});

var h600 = 0;

function bannerFixed() {
    var h = 2750;
    var h2 = 0;
    if ($('.singlePost__sidebarRight').length) {
        h = $('.singlePost__sidebarRight').height() + h600 - 320;
    }
    if ($('#body_epoznan').length) {
        h2 = $('#body_epoznan').height() - 510;
    }
    if ($('#sportContainer').length) {
        h2 = $('#sportContainer').height() - 510;
    }
    if (($('html').attr('data-scroll') >= h) && ($('html').attr('data-scroll') <= h2)) {
        $('#fixedBanner').css('position', 'fixed');
        $('#fixedBanner').css('z-index', '1');
        $('#fixedBanner').css('top', '50px');
        h600 = 600;
    }
    else {
        $('#fixedBanner').css('position', 'initial');
        $('#fixedBanner').css('z-index', '0');
        h600 = 0;
    }
    if ($('.bannerBox__mob').length > 0) {
        var w = $('.bannerBox__mob').width();
        var left = Math.round(($(window).width() - w) / 2);
        $('.bannerBox__mob').css('left', "" + left + "px");
        if (($('html').attr('data-scroll') >= 100) && ($(window).width() <= 972)) {
            $('.bannerBox__mob').css('position', 'fixed');
            $('.bannerBox__mob').css('z-index', '1');
            $('.bannerBox__mob').css('top', '-12px');
            $('.bannerBox__mob').css('width', '100%');
            $('.bannerBox__mob').css('background-color', '#fff');
            if($('#emptyDiv').length == 0) {
                $('.bannerBox__mob').after('<div id="emptyDiv" style="clear: both; width: 100%; height: 82px"></div>');
            }
            $('.bannerBox__mob').css('width', "" + w + "px");

            $('.header__top').hide();
            $('.header').css('bottom', '-90px');
            $('.header').css('top', 'auto');
            $('.header').css('border-top', 'solid 1px #004986');
        }
        else {
            $('.bannerBox__mob').css('position', 'initial');
            $('.bannerBox__mob').css('z-index', '0');
            $('#emptyDiv').remove();

            $('.header__top').show();
            $('.header').css('bottom', 'auto');
            $('.header').css('top', '0');
            $('.header').css('border-top', '');
        }
    }
}

function openLoginForm() {
    $('#login-form-popup').addClass('popup--active');
}

function alertPopup(text) {
    $('#alert-popup .popup__message').html(text);
    $('#alert-popup').addClass('popup--active');
}

function closeAlert() {
    $('#alert-popup').removeClass('popup--active');
}

function alertPopupEnd(text) {
    $('#alert-popup-end .popup__message').html(text);
    $('#alert-popup-end').addClass('popup--active');
}

function closeAlertEnd() {
    $('#alert-popup-end').removeClass('popup--active');
    closePopups();
}

function closePopups() {
    $('.popup').removeClass('popup--active');
}

function login(form_id) {
    $.ajax({
        url: '/login',
        type: 'post',
        dataType: 'json',
        data: $('form#' + form_id).serialize(),
        success: function(data) {
            alertPopup(data.message);
            if (data.status == 'login') {
                $('#login-form-container').hide();
                $('#login-link-2').hide();
                $('#logout-link').show();
                $('#logout-link-2').show();
                $('#logout-link-span').html('Witaj ' + data.name + ' | <a href="editUser" id="edit-link">Edytuj</a> | <a href="javascript: logout(\'login-form\');" id="logout-link">Wyloguj</a>');

                $('#comment-form-author').hide();
                $('#comment-form-avatar').attr('style', "background-image: url('" + data.avatar + "');");
                $('#comment-form-avatar').show();
                $('#comment-form-name').html(data.name);
                $('#comment-form-name').show();

                $('.commentsForm__file-content').html(data.file_view);

                $('#login-form-popup').removeClass('popup--active');
            }
        }
    });
}

function logout(form_id) {
    $.ajax({
        url: '/logout',
        type: 'post',
        dataType: 'json',
        data: $('form#' + form_id).serialize(),
        success: function(data) {
            alertPopup(data.message);
            $('#login-form-container').show();
            $('#login-link-2').show();
            $('#logout-link').hide();
            $('#logout-link-2').hide();
            $('#logout-link-span').html('');

            $('.commentsForm__file-content').html('');

            $('#comment-form-author').show();
            $('#comment-form-avatar').hide();
            $('#comment-form-name').hide();
        }
    });
}

function showComments(news_id, page, scroll_after) {
    $.getJSON('/showComments?news_id='+news_id+'&page='+page, function(data) {
        $('#parent_comments_container_2').html(data.view);
        $('.comments__text').magnificPopup({
            delegate: '.comments__photo',
            type: 'image'
        });
        if (scroll_after == true) {
            $('html, body').animate({ scrollTop: $('#pagination-up').offset().top - 52 }, 500);
        }
        var buttons = document.querySelector('.comments').querySelectorAll('.comments__like');
        buttons.each((item) => {
            item.addEventListener('click', (e) => {
              e.preventDefault()
              saveVote(e.currentTarget)
            })
        });
    });
}

function saveVote(button) {

    const wrapper = button.parentNode;
    var comment_id = button.getAttribute('data-comment-id');
    var type = button.getAttribute('data-type');

    $.getJSON('/voteForComment?comment_id='+comment_id+'&type='+type, function(data) {
        if (data.status == 'error') {
            alert(data.message);
            wrapper.addClass('comments__likes--disabled');
            button.addClass('comments__like--active');
        }
        else {
            wrapper.addClass('comments__likes--disabled');
            button.addClass('comments__like--active');
            button.innerHTML = data.points;
            setCookie('cv_'+comment_id, 1, 365);
        }
    });
}

function showCommentMore(comment_id) {
    $('#popular-comment-link-more-'+comment_id).hide();
    $('#popular-comment-more-'+comment_id).show();
}

function showHiddenComment(id) {
    $('#comment-click-' + id).hide();
	$('#comment-after-click-' + id).show();
}

function enableErrorSubmit() {
	$('#error-ready-to-send').val('1');
}

function enableRegisterSubmit() {
    $('#register-ready-to-send').val('1');
}

function enableCommentSubmit() {
    $('#comment-ready-to-send').val('1');
}

function enableContactSubmit() {
	$('#ready-to-send').val('1');
}

function setDeleteCommentId(id) {
    $('#delete-comment-id').val(id);
    $('#delete-comment-popup').addClass('popup--active');
}

function setAnswerCommentId(id, parent_id) {
    $('#answer-comment-id').val(parent_id);
    $('#comment-form-answer-box').html('<h4 class="commentsForm__answerTitle">Odpowiadasz na komentarz:</h4><p class="commentsForm__answerText">' + $('#comment-text-' + id).html() + '</p>');
    $('html, body').animate({ scrollTop: $('#comment-form').offset().top - 120 }, 500);
}

function sendCommentForm() {
	var ready = $('#comment-ready-to-send').val();
	if (ready == "0") {
        alertPopup("Pole 'Nie jestem robotem' musi być zaznaczone.");
    }
    else if ($('#comment-textarea').val() == '') {
        alertPopup("Pole 'Treść komentarza' musi być wypełnione.");
    }
    else if ($('#comment-textarea').val().length > 1000) {
        alertPopup("Treść komentarza może mieć maksymalnie 1000 znaków.");
    }
	else {
        $("form#comment-form").submit();
	}
}

function sendDeleteCommentForm() {

    if ($('#delete-comment-reason').val() == '') {
        alertPopup("Pole 'Powód' musi być wypełnione.");
    }
	else {
        $("form#delete-comment-form").submit();
	}
}

function sendContactForm() {
	var ready = $('#ready-to-send').val();
	if (ready == "0") {
		alertPopup("Pole 'Nie jestem robotem' musi być zaznaczone.");
    }
    else if (($('#contact-textarea').val() == '') && ($('#contact-sender').val() == '')) {
        alertPopup("Wypełnij pola formularza.");
    }
	else {
        $("form#contact-form").submit();
	}
}

function sendErrorReportForm() {
    var textarea = $('#error-textarea').val();
    var sender = $('#error-sender').val();
    var ready = $('#error-ready-to-send').val();
	if (ready == "0") {
        alertPopup("Pole 'Nie jestem robotem' musi być zaznaczone.");
    }
	else if ((textarea == "") || (sender == "")) {
		alertPopup('Wypełnij pola formularza');
	}
	else {
        $("#error-form").submit();
        $('#news-error-overlay').hide();
	}
}

function sendConfessionForm() {

    var name_val = $('#confession-form-name').val();
    var emotion_val = $('input[name=face]:checked', '#confession-form').val();
    var text_val = $('#confession-form-text').val();
    if (emotion_val == null || emotion_val == false || emotion_val == '' || name_val == '' || text_val == '') {
        if (text_val == '') { $('#confession-form-text').css('background-color', 'rgb(255, 220, 220)');}
        if (emotion_val == null || emotion_val == false || emotion_val == '') { $('.messagesList__icons').css('background-color', 'rgb(255, 220, 220)');}
        if (name_val == '') { $('#confession-form-name').css('background-color', 'rgb(255, 220, 220)');}
        alertPopup('Wypełnij brakujące pola.');
    }
    else {
        $('#confession-form').submit();
    }
}

function sendSpottedForm() {

    var name_val = $('#spotted-form-name').val();
    var contact_val = $('#spotted-form-contact').val();
    var text_val = $('#spotted-form-text').val();
    if (contact_val == '' || name_val == '' || text_val == '') {
        if (text_val == '') { $('#spotted-form-text').css('background-color', 'rgb(255, 220, 220)');}
        if (contact_val == '') { $('#spotted-form-contact').css('background-color', 'rgb(255, 220, 220)');}
        if (name_val == '') { $('#spotted-form-name').css('background-color', 'rgb(255, 220, 220)');}
        alertPopup('Wypełnij brakujące pola.');
    }
    else {
        $('#spotted-form').submit();
    }
}

function sendNewPasswordForm() {
    $("#remember-password-form").submit();
}

function searchPaddingLeft() {
    $('#q_search').css('padding-left', '10px');
    $('.header__searchInput').css('width', '223px');
    $('.header__searchInput').css('height', '25px');
    $('.header__searchInput').css('border-left', '1px solid rgb(126, 157, 185)');
    $('.header__searchInput').css('border-right', '0');
    $('.header__searchInput').css('border-top', '0');
    $('.header__searchInput').css('border-bottom', '0');
    $('.header__searchInput').css('background-color', '#fff');
}

function hideNewsGalleryLightbox()
{
	$("div#news-gallery-dialog").hide();
	$("div#news-gallery-overlay").hide();
	$("div#news-gallery-arrows-container").hide();
	$("div#news-gallery-arrows-overlay-container").hide();
}

function showNewsGalleryLightbox(gallery_id, file_base_name)
{
	var rand = Math.floor((Math.random()*100)+1);
	$("div#news-gallery-dialog-img").html('<img id="news-gallery-img" src="gallery2/' + gallery_id + '/' + file_base_name + '_gallery.jpg?' + rand + '" />');

   	$.getJSON("ajax/get_json_for_news_lightbox.php?news_id="+news_id+"&gallery_id="+gallery_id+"&file_base_name="+file_base_name, function(data) {

		var img = $("#news-gallery-img")[0];
		$("<img/>") // Make in memory copy of image to avoid css issues
    	.attr("src", $(img).attr("src"))
    	.load(function() {
	        $("div#news-gallery-dialog").width(this.width + 20);
	        $("div#news-gallery-dialog").height(this.height + 60);
	        $("div#news-gallery-dialog-img").width(this.width);
	        $("div#news-gallery-dialog-img").height(this.height);
			$("div#news-gallery-dialog-bottom").width(this.width + 10);
			$("div#news-gallery-dialog-bottom-label").html(data.description);
			var new_w = parseInt(($(window).width() - (this.width + 20)) / 2);
			var new_h = parseInt(($(window).height() - (this.height + 60)) / 2);
			$("div#news-gallery-dialog").css("top", new_h + "px");
			$("div#news-gallery-dialog").css("left", new_w + "px");
			$("#news-gallery-overlay").show();
			$("div#news-gallery-dialog").show();

			$("div#news-gallery-arrows-container").width(this.width + 20);
	        $("div#news-gallery-arrows-container").height(this.height);
			$("div#news-gallery-arrows-container").css("top", new_h + "px");
			$("div#news-gallery-arrows-container").css("left", new_w + "px");
			$("div#news-gallery-arrows-overlay-container").width(this.width + 20);
	        $("div#news-gallery-arrows-overlay-container").height(this.height);

	        $("div#news-gallery-arrows-overlay-left").width(parseInt(this.width / 2));
	        $("div#news-gallery-arrows-overlay-left").height(this.height);
	        $("div#news-gallery-arrows-overlay-left").mouseenter(function() {
	        	$("div#news-gallery-arrows-left").show();
	        });
	        $("div#news-gallery-arrows-overlay-left").mouseout(function() {
	        	$("div#news-gallery-arrows-left").hide();
	        });

	        $("div#news-gallery-arrows-overlay-right").width(parseInt(this.width / 2));
	        $("div#news-gallery-arrows-overlay-right").height(this.height);
	        $("div#news-gallery-arrows-overlay-right").mouseenter(function() {
	        	$("div#news-gallery-arrows-right").show();
	        });
	        $("div#news-gallery-arrows-overlay-right").mouseout(function() {
	        	$("div#news-gallery-arrows-right").hide();
	        });

			$("div#news-gallery-arrows-overlay-container").css("top", new_h + "px");
			$("div#news-gallery-arrows-overlay-container").css("left", new_w + "px");

			if (data.preview_file != '' || data.next_file != '') {
				$("div#news-gallery-arrows-container").show();
		        if (data.preview_file != '') {
		        	$("a#a-news-gallery-arrows-overlay-left").attr('rel', 'lightbox['+gallery_id+']');
		        	$("a#a-news-gallery-arrows-overlay-left").attr('href', 'gallery2/' + gallery_id + '/' + data.preview_file + '_gallery.$pg');
	        		$("a#a-news-gallery-arrows-overlay-left").attr('title', data.preview_description);
	        		$("a#a-news-gallery-arrows-overlay-left").click(function() { hideNewsGalleryLightbox();});
	        		$("div#news-gallery-arrows-overlay-left").show();
		        }
		        if (data.next_file != '') {
		        	$("a#a-news-gallery-arrows-overlay-right").attr('rel', 'lightbox['+gallery_id+']');
		        	$("a#a-news-gallery-arrows-overlay-right").attr('href', 'gallery2/' + gallery_id + '/' + data.next_file + '_gallery.$pg');
	        		$("a#a-news-gallery-arrows-overlay-right").attr('title', data.next_description);
	        		$("a#a-news-gallery-arrows-overlay-right").click(function() { hideNewsGalleryLightbox();});
	        		$("div#news-gallery-arrows-overlay-right").show();
		        }
		        $("div#news-gallery-arrows-overlay-container").show();
			}
    	});
	});
}

function getLastMatchPosts() {

    var match_id = $('#match-id').val();
    var last_match_post_id = $('#last-match-post-id').val();

    $.getJSON("/getLastMatchPosts?id="+match_id+"&last_post_id="+last_match_post_id, function(data) {

        $('#last-match-post-id').val(data.last_post_id);
        $('.matchProgress__course .simplebar-content').prepend(data.view);
        if (data.last_post_time != '00:00') {
            $('.matchProgress__endTime').html(data.last_post_time);
        }
    });
    setTimeout("getLastMatchPosts()", 30000);
}

// Adsys 19
function findPosX(obj)
{
   	var curleft = 0;
	if(obj.offsetParent)
        while(1)
        {
			curleft += obj.offsetLeft;
			if(!obj.offsetParent)
            break;
			obj = obj.offsetParent;
        }
	else if(obj.x)
       curleft += obj.x;
	return curleft;
 }

function getWindowScrollPosition() {
    var scrOfY = 0;
	if( typeof( window.pageYOffset ) == 'number' ) {
	    //Netscape compliant
	    scrOfY = window.pageYOffset;
	} else if( document.body && ( document.body.scrollLeft || document.body.scrollTop ) ) {
	    //DOM compliant
	    scrOfY = document.body.scrollTop;
	} else if( document.documentElement && ( document.documentElement.scrollLeft || document.documentElement.scrollTop ) ) {
	    //IE6 standards compliant mode
	    scrOfY = document.documentElement.scrollTop;
    }
    return scrOfY;
}

function getScrollY()
{
	var scrOfY = getWindowScrollPosition();
	scrOfY += 50;
	return scrOfY;
}

function moveAdsys19()
{
	var reklama_obj = document.getElementById('adsys-19');
	if (reklama_obj)
	{
		reklama_obj.style.left = findPosX(document.getElementById('mainContainer'))-155+'px';
		reklama_obj.style.top = getScrollY()+'px';
	}
}
// Adsys 19 end.

function showAdsys(placement_id, section) {
    
    var adsys_capping = getCookie('ad_capping');

    var screen_adsys_id = 0;
    var screen_placement_id = 0;

    if ($('#screen_adsys_id').length) {
        screen_adsys_id = $('#screen_adsys_id').val();
    }

    if ($('#screen_placement_id').length) {
        screen_placement_id = $('#screen_placement_id').val();
    }

    $.ajax({
        url: "/getAdsysCode",
        type: 'GET',
        async: false,
        data: {placement_id:placement_id,section:section,adsys_capping:adsys_capping,screen_adsys_id:screen_adsys_id,screen_placement_id:screen_placement_id},
        success:function(output){
            if (placement_id == 39) {
                if (output.html != '') {
                    $("body").attr('style', 'background-image: url(\'' + output.html + '\'); background-position: center 0; background-attachment: fixed; background-repeat: no-repeat;');
                    setCookie('ad_capping', output.capping, 360);
                    $('.footer__boxesWrapper').append(output.ga_code);
                    $("body").click(function(event) {
                        if (event.target.id == 'body_epoznan') {
                            window.open("//epoznan.pl/adsysClick?id=" + output.id, '_blank');
                        }
                    });
                }
                else {
                    showAdsys(19, section);
                }
            }
            if (output.html != '') {
                $('#adsys-' + placement_id).html(output.html);
                setCookie('ad_capping', output.capping, 360);
                if (placement_id == 19) {
                    moveAdsys19();
                }
            }
        }
    });
}

var actualComment = 1;
var maxComment = 7;

function popularCommentsChange(direction) {

    var w = parseInt($(window).width());
    var showComments = 3;
    if (w <= 700) {
        showComments = 2;
    }
    if (w <= 500) {
        showComments = 1;
    }
    if (direction == 'right') {
        if (actualComment < (maxComment - showComments + 1)) {
            actualComment++;
        }
    }
    else if (direction == 'left') {
        if (actualComment > 1) {
            actualComment--;
        }
    }
    $('.commentsList__item').hide();
    for (var i = actualComment; i < (actualComment + showComments); i++) {
        $('#popular-comment-' + i).show();
    }
    var leftColor = '#707070';
    var rightColor = '#707070';
    if (actualComment >= (maxComment - showComments + 1)) {
        rightColor = '#bbb';
    }
    if (actualComment <= 1) {
        leftColor = '#bbb';
    }
    $('#pagination-1 .commentsList__paginationArrow--left').css('color', leftColor);
    $('#pagination-1 .commentsList__paginationArrow--right').css('color', rightColor);
}

function toggleVisibility(id) {
    var e = document.getElementById(id);
    if (e.style.display == 'block') {
       e.style.display = 'none';
    } else {
       e.style.display = 'block';
    }
}

function mpkVariantShowOrHide(ul_id) {
	if ($('#' + ul_id + ':visible').is(':visible')) {
		$('#' + ul_id + ':visible').hide();
	}
	else {
		$('#' + ul_id + ':hidden').show();
	}
}

//----------------------CANVAS-----------------------

function murmurhash3_32_gc(key, seed) {
    var remainder, bytes, h1, h1b, c1, c2, k1, i;

    remainder = key.length & 3; // key.length % 4
    bytes = key.length - remainder;
    h1 = seed;
    c1 = 0xcc9e2d51;
    c2 = 0x1b873593;
    i = 0;

    while (i < bytes) {
        k1 =
            ((key.charCodeAt(i) & 0xff)) |
            ((key.charCodeAt(++i) & 0xff) << 8) |
            ((key.charCodeAt(++i) & 0xff) << 16) |
            ((key.charCodeAt(++i) & 0xff) << 24);
        ++i;

        k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
        k1 = (k1 << 15) | (k1 >>> 17);
        k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;

        h1 ^= k1;
        h1 = (h1 << 13) | (h1 >>> 19);
        h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
        h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
    }

    k1 = 0;

    switch (remainder) {
        case 3: k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
        case 2: k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
        case 1: k1 ^= (key.charCodeAt(i) & 0xff);

            k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
            k1 = (k1 << 15) | (k1 >>> 17);
            k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
            h1 ^= k1;
    }

    h1 ^= key.length;

    h1 ^= h1 >>> 16;
    h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
    h1 ^= h1 >>> 13;
    h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
    h1 ^= h1 >>> 16;

    return h1 >>> 0;
}

function javaHashCode(string, K) {
    var hash = 0;
    if (string.length === 0) {
        return hash;
    }
    for (var i = 0; i < string.length; i++) {
        char = string.charCodeAt(i);
        hash = K*((hash<<5)-hash)+char;
        hash = hash & hash;
    }
    return hash;
}

'use strict';

var Fingerprint = function (options) {
    var nativeForEach, nativeMap;
    nativeForEach = Array.prototype.forEach;
    nativeMap = Array.prototype.map;

    this.each = function (obj, iterator, context) {
        if (obj === null) {
            return;
        }
        if (nativeForEach && obj.forEach === nativeForEach) {
            obj.forEach(iterator, context);
        } else if (obj.length === +obj.length) {
            for (var i = 0, l = obj.length; i < l; i++) {
                if (iterator.call(context, obj[i], i, obj) === {}) return;
            }
        } else {
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    if (iterator.call(context, obj[key], key, obj) === {}) return;
                }
            }
        }
    };

    this.map = function(obj, iterator, context) {
        var results = [];
        if (obj == null) return results;
        if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
        this.each(obj, function(value, index, list) {
            results[results.length] = iterator.call(context, value, index, list);
        });
        return results;
    };

    if (typeof options == 'object'){
        //Overloading for passing draw or now some data on canvas - good for demonstration purposes
        this.hasher = options.hasher;
        this.canvas = options.canvas;
    } else if(typeof options == 'function'){
        //Overloading for custom hash functions
        this.hasher = options;
    }
};

Fingerprint.prototype = {
    get: function(){
        var keys = [];
        keys.push(navigator.userAgent);
        //keys.push(navigator.language);
        keys.push(screen.colorDepth);
        keys.push(this.getScreenResolution().join('x'));
        //keys.push(new Date().getTimezoneOffset());
        keys.push(this.hasSessionStorage());
        keys.push(this.hasLocalStorage());
        keys.push(this.hasIndexDb());
        //body might not be defined at this point or removed programmatically
        if(document.body){
            keys.push(typeof(document.body.addBehavior));
        } else {
            keys.push(typeof undefined);
        }
        keys.push(typeof(window.openDatabase));
        keys.push(navigator.cpuClass);
        keys.push(navigator.platform);
        keys.push(navigator.doNotTrack);
        keys.push(this.getPluginsString());
        if(this.canvas && this.isCanvasSupported()){
            keys.push(this.getCanvasFingerprint());
        }
        if(this.hasher){
            return this.hasher(keys.join('###'), 31);
        } else {
            return murmurhash3_32_gc(keys.join('###'), 31);
        }
    },

    /**
     * If catch SecurityError, it means it exists
     * @returns {boolean} has local storage
     */
    hasLocalStorage: function () {
        try{
            return !!window.localStorage;
        } catch(e) {
            return true;
        }
    },

    /**
     * If catch SecurityError, it means it exists
     * @returns {boolean} has session storage
     */
    hasSessionStorage: function () {
        try{
            return !!window.sessionStorage;
        } catch(e) {
            return true;
        }
    },

    /**
     * If catch SecurityError, it means it exists
     * @returns {boolean} has IndexDb
     */
    hasIndexDb: function () {
        try{
            return !!window.indexedDB;
        } catch(e) {
            return true;
        }
    },

    isCanvasSupported: function () {
        var elem = document.createElement('canvas');
        return !!(elem.getContext && elem.getContext('2d'));
    },

    isIE: function () {
        if(navigator.appName === 'Microsoft Internet Explorer') {
            return true;
        } else if(navigator.appName === 'Netscape' && /Trident/.test(navigator.userAgent)){
            return true;
        }
        return false;
    },

    getPluginsString: function () {
        if(this.isIE()){
            return this.getIEPluginsString();
        } else {
            return this.getRegularPluginsString();
        }
    },

    getRegularPluginsString: function () {
        return this.map(navigator.plugins, function (p) {
            var mimeTypes = this.map(p, function(mt){
                return [mt.type, mt.suffixes].join('~');
            }).join(',');
            return [p.name, p.description, mimeTypes].join('::');
        }, this).join(';');
    },

    /**
     * Fetch plugins specific to IE
     */
    getIEPluginsString: function () {
        if(window.ActiveXObject){
            var names = ['ShockwaveFlash.ShockwaveFlash',
                'AcroPDF.PDF',
                'PDF.PdfCtrl',
                'QuickTime.QuickTime',
                'rmocx.RealPlayer G2 Control',
                'rmocx.RealPlayer G2 Control.1',
                'RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)',
                'RealVideo.RealVideo(tm) ActiveX Control (32-bit)',
                'RealPlayer',
                'SWCtl.SWCtl',
                'WMPlayer.OCX',
                'AgControl.AgControl', // Silverlight
                'Skype.Detection'];

            return this.map(names, function(name){
                try{
                    new ActiveXObject(name);
                    return name;
                } catch(e){
                    return null;
                }
            }).join(';');
        } else {
            return "";
        }
    },

    getScreenResolution: function () {
        return (screen.height > screen.width) ? [screen.height, screen.width] : [screen.width, screen.height];
    },

    getCanvasFingerprint: function () {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        // https://www.browserleaks.com/canvas#how-does-it-work
        var txt = 'CANVAS_FINGERPRINT';
        ctx.textBaseline = "top";
        ctx.font = "14px 'Arial'";
        ctx.textBaseline = "alphabetic";
        ctx.fillStyle = "#f60";
        ctx.fillRect(125,1,62,20);
        ctx.fillStyle = "#069";
        ctx.fillText(txt, 2, 15);
        ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
        ctx.fillText(txt, 4, 17);
        return canvas.toDataURL();
    }
};

//Linki E i P

function adminEditLinks()
{

    $.getJSON('/checkLoginAdmin', function(data) {

        if (data.status == "1") {
            var elements = document.getElementsByClassName('news_epoznan');
            var el_len = elements.length;
            for(var x = 0;x < el_len; x++)
            {
                var news_id_1 = elements[x].id;
                var index = news_id_1.indexOf("-");
                var news_id = news_id_1.substr(5, 6);
                var show_form = news_id_1.substr(11);
                elements[x].innerHTML = ' <a href="https://redakcja.epoznan.pl/editor/news/'+news_id+'/edit" target="_blank" title="edycja newsa">[e]</a>';
                if ($('.largePhoto').length) {
                    elements[x].innerHTML += '<a href="https://redakcja.epoznan.pl/editor/news/'+news_id+'/public/change" target="_blank" title="zdjęcie z publikacji">[p]</a>';
                }
            }

            var elements2 = document.getElementsByClassName('wydarzenia_epoznan');
            var el_len2 = elements2.length;
            for(var y = 0;y < el_len2; y++)
            {
                var event_id_2 = elements2[y].id;
                var index = event_id_2.indexOf("-");
                var event_id = event_id_2.substr(7, 5);
                var show_form = event_id_2.substr(13);

                elements2[y].innerHTML = ' <a class="epoznan_events_link" href="admin/edit.php?q=kalendarium&id='+event_id+'&show_from='+show_form+'#formularz_dodawania" target="_blank" title="edycja wydarzenia">e</a> <a class="epoznan_events_link" href="admin/publish.php?q=kalendarium&id='+event_id+'&m=0" target="_blank" title="zdjęcie z publikacji" style="margin-left: 4px;">p</a>';
            }

            var elements3 = document.getElementsByClassName('comments_epoznan');
            var el_len3 = elements3.length;
            for(var z = 0;z < el_len3; z++)
            {
                var comment_id = elements3[z].id;
                comment_id = comment_id.slice(8);

                elements3[z].innerHTML = ' <a class="text" href="admin/publish.php?q=forum2_comment_sys&id='+comment_id+'&m=0" target="_blank" title="zdjęcie z emisji">p</a>';
            }
        }
    });

}
